module.exports = __webpack_public_path__ + "static/media/bq-etl-load.3d3feebd.png";